import { getCurrentUser } from "../firebase/auth";

export function getToken() {
 const { accessToken } = getCurrentUser()
 return accessToken
}